import '../../styles/theme/index.scss';
import { initImageGalleries } from "./images";
import { initEventBrite } from './eventbrite';
import { initMenus } from './menus';

(() => {
    initMenus()
    initImageGalleries();
    initEventBrite('eventBriteTrigger');
})();
